/* t7-2a (#516 a #520) -- LOS AYUDANTES PUROS DE LA PAGINA "AVANCE DEL GRUPO".

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   Todo el calculo vive en el servidor (`backend/services/pipe_inst/avance.py`); aqui solo lo
   que la pagina hace con el reloj y el idioma del NAVEGADOR:
     - "cuando" ("hoy", "ayer", "hace n dias", "nunca") a partir del ISO, con las fechas de
       calendario LOCALES del aparato (como el historial de #509);
     - la hora de "Datos de hoy, {{hora}}" con `Intl` (es-MX a 24 horas, en-US con AM/PM);
     - los colores de los cinco estados (#526) y los tramos de una barra;
     - t7-2c (#532, la cara v5): los temas de la portada, el chip de caducidad de una card, la
       flecha de "Va mejorando?" y las negritas del "x de y".
   Ningun numero se recalcula: la pagina pinta lo que el servidor manda.

   LAPIDA t7-2c (#532): murieron `destinoDelAncla`, `frasesEnOrden`, `columnaDeLaRegla`,
   `partirFrase` y `detenido`: la portada v5 ya no pinta el plan (vive en el correo y en el
   chat) ni sus anclas "Ver" / "Abrir en curacion", y `detente` sale siempre vacio. */

import { localeDeFecha } from './fechaDeSesion';

/** Los cinco estados de un tema (#526), en el orden en que se pintan (barras, leyenda,
    conteos): verde lleno, verde de contorno ("va bien, le falta practicar"), amarillo, rojo,
    gris. La card solo usa cuatro: no tiene contorno. */
export const ESTADOS = ['V', 'va_bien', 'A', 'R', 'S'];

/** t7-2a remate 2 (v3 3.2): los estados de la cabecera de una card. RE-ANCLADA EN t7-3 remate 3 (#569): ya
    no son los cuatro del Readiness (Dominan, A medias, Les cuesta y Sin practicar) sino los SEIS de una
    publicacion por alumno, en el orden de sus tramos: Domina, Va bien, A medias, Le cuesta, Ha practicado
    poco (`poco`, solo de una publicacion) y Sin practicar. */
export const ESTADOS_DE_LA_CARD = ['V', 'va_bien', 'A', 'R', 'poco', 'S'];

/** Los colores del diseno (seccion 3.6). El de contorno no tiene relleno: se pinta con su
    borde (`VERDE`, 2 px en cuadritos y tabla) y, en las barras, con `TRAMO_VA_BIEN`. */
export const VERDE = '#3ddc84';
export const AMARILLO = '#f5b942';
export const ROJO = '#e5484d';
export const NARANJA = '#FF6B00';
/** t7-3 remate 7 (#582 A): EL GRIS NUEVO, una sola constante para toda la cara del profe: el tramo y el cuadrito de
    "Sin practicar", el "sin contestar" de la barrita del alumno, la pista de toda barra (tambien la barra entera de
    un conteo en "nadie"), los cuadros de la tabla, los numeros de ese estado y el contorno de "Ha practicado poco".
    El gris de antes (#2a2a2a, con borde #3a3a3a) se perdia contra el fondo. Contra la tarjeta (#181818) da 4.8 a 1. */
export const GRIS_DE_LAS_BARRAS = '#858585';
export const COLOR_DEL_ESTADO = {
  V: VERDE,
  va_bien: 'transparent',
  A: AMARILLO,
  R: ROJO,
  S: GRIS_DE_LAS_BARRAS,
  // t7-3 remate 3 (#569): "Ha practicado poco" no tiene relleno: se pinta con su contorno gris (`BORDE_POCO`)
  poco: 'transparent',
};
/** El borde gris de los chips que NO son barras (motivo "nunca" / "dejo" y la caducidad gris del mosaico). */
export const BORDE_SIN_PRACTICAR = '#3a3a3a';
/** El tramo "va bien" de una barra: el verde al 18 % y un borde de 1 px del mismo verde. */
export const TRAMO_VA_BIEN = 'rgba(61,220,132,0.18)';
/** t7-3 remate 3 (#569): "Ha practicado poco": el contorno de 2 px (el dibujo del verde de contorno, en gris).
    RE-ANCLADA EN t7-3 remate 7 (#582 A): el contorno es el gris nuevo (antes #a0a0a0) y, en una barra, el tramo
    tambien es contorno sin relleno (antes un tramo relleno #6a6a6a). */
export const BORDE_POCO = GRIS_DE_LAS_BARRAS;
export const TRAMO_POCO = 'transparent';
/** El riel de las barras (lo que queda sin tramo) y el gris de "sin contestar" en la barrita. RE-ANCLADA EN t7-3
    remate 7 (#582 A): el gris nuevo (antes #2a2a2a). */
export const RIEL = GRIS_DE_LAS_BARRAS;

/** t7-3 remate 7 (#582 A): un color mezclado con el fondo de su tarjeta (`alfa` del color, el resto del fondo), en
    hexadecimal. La barra de la semana anterior es la de hoy al 75 % sobre la tarjeta: con opacidad se mezclaria con
    la pista gris y se ensuciaria. */
export function atenuado(color, fondo, alfa = 0.75) {
  const rgb = (h) => [1, 3, 5].map((i) => parseInt(String(h).slice(i, i + 2), 16));
  const a = rgb(color);
  const f = rgb(fondo);
  return `#${a.map((x, i) => Math.round(alfa * x + (1 - alfa) * f[i]).toString(16).padStart(2, '0')).join('')}`;
}

/** El texto sobre el chip de estado de una card (seccion 3.2). */
export const TEXTO_SOBRE_EL_ESTADO = {
  V: '#111111',
  va_bien: VERDE,
  A: '#111111',
  R: '#ffffff',
  // t7-3 remate 7 (#582 A): sobre el gris nuevo, el texto oscuro que el panel ya usa (5.1 a 1)
  S: '#111111',
  poco: '#c9c9c9',
};

/* LAPIDA t7-2d (#542 a #544, la portada v3): murieron `TOPE_PORTADA` (la portada ya no pinta
   hasta 5 renglones por respuesta: un renglon por motivo, un tema con su pregunta y dos pares de
   barras), `temasDeLaPortada` y `hayDatosDeTemas` (el tema lo decide la cascada del servidor) y
   `flecha` (la v6 quito las flechas y el "eran n" de "Va mejorando?"). */

/** t7-2d (#542): los motivos de riesgo en su orden de prioridad (diseno v6 seccion 2.3). */
export const MOTIVOS = ['nunca', 'dejo', 'le_cuestan', 'se_atoro', 'poco'];
/** t7-3 remate 8 (#589): la marca que pide el quinto motivo; sin ella el servidor contesta los cuatro de siempre (la
    web vieja durante el despliegue y las apps publicadas). */
export const MARCA_DE_MOTIVOS = '5';

/** t7-2d (#546): con 3 alumnos o menos, "Mejoraron" y los demas conteos van con nombres; con mas,
    "Mejoraron esta semana" pinta hasta 2 renglones y "Ver todos" despliega el resto. */
export const RENGLONES_MEJORARON = 2;

const MARCAS = new RegExp('[' + String.fromCharCode(0x300) + '-' + String.fromCharCode(0x36f) + ']', 'g');

/** t7-2d (#547): un nombre para buscar: sin acentos ni mayusculas ("Mar\xeda" -> "maria"). */
export function sinAcentos(texto) {
  return String(texto || '').normalize('NFD').replace(MARCAS, '').toLowerCase();
}

/** t7-2d (#544): el ancho de una barra de conteo, "x de y" en por ciento con un decimal. */
export function anchoDeConteo(n, y) {
  if (!y || !n) return '0%';
  return `${Math.round((1000 * Math.min(n, y)) / y) / 10}%`;
}

/** t7-3 remate 8 (#591, C18): los nombres de un aviso unidos como lista del idioma: "A y B", "A, B y C" / "A and B",
    "A, B and C". (La casa no tenia una funcion que uniera nombres: nace aqui, sin Intl, para que sea igual en todo
    navegador.) */
export function unirNombres(nombres, idioma) {
  const lista = (nombres || []).filter(Boolean);
  if (lista.length <= 1) return lista.join('');
  const y = String(idioma || 'es').toLowerCase().startsWith('en') ? 'and' : 'y';
  return `${lista.slice(0, -1).join(', ')} ${y} ${lista[lista.length - 1]}`;
}

/** t7-2d: una lista de nombres ("Ana, Bruno") o, vacia, la palabra del cero ("nadie"). */
export function listaDeNombres(t, nombres) {
  return (nombres || []).length ? nombres.join(', ') : t('groups.avance.nadie');
}

function inicioDelDia(d) {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
}

/** Dias de calendario LOCALES entre el ISO y ahora (0 = hoy), o null sin fecha. */
export function diasDesde(iso, ahora = new Date()) {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return Math.round((inicioDelDia(ahora) - inicioDelDia(d)) / 86400000);
}

/** "hoy" / "ayer" / "hace n dias" / "nunca", con las llaves de `groups.avance.cuando`. */
export function cuandoTexto(t, iso, ahora = new Date()) {
  const dias = diasDesde(iso, ahora);
  return cuandoDeDias(t, dias);
}

/** t7-3 remate 8 (#583, C67): los milisegundos que faltan para la siguiente medianoche del NAVEGADOR, mas 5 s (el
    momento en que la pagina vuelve a pedir el avance: los numeros de "los ultimos 7 dias" cambian a la medianoche). */
export const MARGEN_DE_MEDIANOCHE_MS = 5000;
export function msHastaLaMedianoche(ahora = new Date()) {
  const siguiente = new Date(ahora.getFullYear(), ahora.getMonth(), ahora.getDate() + 1, 0, 0, 0, 0);
  return siguiente.getTime() - ahora.getTime() + MARGEN_DE_MEDIANOCHE_MS;
}

/** Lo mismo desde un numero de dias ya calculado por el servidor (null = nunca). */
export function cuandoDeDias(t, dias) {
  if (dias === null || dias === undefined) return t('groups.avance.cuando.nunca');
  if (dias <= 0) return t('groups.avance.cuando.hoy');
  if (dias === 1) return t('groups.avance.cuando.ayer');
  return t('groups.avance.cuando.hace', { count: dias });
}

/** "se unio hoy" / "se unio ayer" / "se unio hace n dias" (n viene del servidor). */
export function seUnioTexto(t, dias) {
  if (dias === null || dias === undefined) return '';
  if (dias <= 0) return t('groups.avance.se_unio_hoy');
  if (dias === 1) return t('groups.avance.se_unio_ayer');
  return t('groups.avance.se_unio', { count: dias });
}

/** La hora local del aparato para "Datos de hoy, {{hora}}" ("18:55" / "6:55 PM"). */
export function horaLocal(iso, idioma, opciones = {}) {
  const d = new Date(iso);
  if (!iso || Number.isNaN(d.getTime())) return '';
  const locale = localeDeFecha(idioma);
  return new Intl.DateTimeFormat(locale, {
    hour: 'numeric', minute: '2-digit',
    ...(locale === 'es-MX' ? { hourCycle: 'h23' } : {}),
    ...(opciones.timeZone ? { timeZone: opciones.timeZone } : {}),
  }).format(d);
}

/** Un numero con separador de miles del idioma ("1,263"). */
export function numero(n, idioma) {
  return new Intl.NumberFormat(localeDeFecha(idioma)).format(n || 0);
}

/** Los tramos de una barra: solo los estados con conteo, en el orden de siempre. Por omision
    los cinco; la cabecera de una card pide los suyos (`ESTADOS_DE_LA_CARD`). */
export function tramos(dist, estados = ESTADOS) {
  return estados.filter((e) => (dist?.[e] || 0) > 0).map((e) => ({ estado: e, n: dist[e] }));
}

/** t7-3 remate 3 (#569, C3): los tramos de la barrita de una publicacion para un alumno, en su orden: lo que
    contesta bien, lo que contesta mal y lo que todavia no contesta; solo los que valen mas de cero (el ancho de
    cada uno es su conteo entre el total; los tres suman el total). */
export function tramosDeLaBarrita(bien, mal, total) {
  const falta = Math.max(0, (total || 0) - (bien || 0) - (mal || 0));
  return [{ clave: 'bien', n: bien || 0 }, { clave: 'mal', n: mal || 0 }, { clave: 'falta', n: falta }]
    .filter((x) => x.n > 0);
}

/** t7-3 remate 8 (#588): los renglones de una publicacion para un alumno, de preguntas DISTINTAS, letra por letra
    `avance_textos.lineas_de_conteos` del servidor: "Ha contestado 7 de 62 preguntas." y "De esas 7, le salen bien 3 y
    mal 4.", con las hermanas que no escriben ceros (todas bien, todas mal, una sola); sin nada contestado, un solo
    renglon "No ha contestado ninguna de las 62 preguntas.". Se calcula con las llaves que ya viajan (`total`, `bien`,
    `mal`): funciona igual contra el servidor de antes. LAPIDA: murio `frasesDeConteos` ("De 62 preguntas: 27 bien, 2
    mal, 33 sin contestar.", con sus piezas). */
export function lineasDeConteos(t, total, bien, mal) {
  const y = total || 0;
  const b = bien || 0;
  const m = mal || 0;
  const x = b + m;
  const p = 'groups.avance.preguntas_pub.';
  if (x <= 0) return [y === 1 ? t(`${p}ninguna_una`) : t(`${p}ninguna`, { y })];
  const uno = y === 1 ? t(`${p}contestado_una`) : t(`${p}contestado`, { x, y });
  let dos;
  if (x === 1) dos = t(b ? `${p}una_bien` : `${p}una_mal`);
  else if (!m) dos = t(`${p}todas_bien`, { x });
  else if (!b) dos = t(`${p}todas_mal`, { x });
  else dos = t(`${p}de_esas`, { x, b, m });
  return [uno, dos];
}

/** El globo de un cuadro de la tabla por card: alumno, tema, estado y "acierta a de b"; el
    gris, sin conteos. RE-ANCLADA EN t7-2c (#532): sin "ha visto b de n" (sigue por dentro). */
export function textoDelCuadro(t, alumno, tema, tm) {
  if (!tm || tm.estado === 'S') return t('groups.avance.cuadro_gris', { alumno, tema });
  // t7-3 remate 7 (regla 5 de #581): con cero aciertos, "no acierta ninguna de b" (la forma del chat), nunca "acierta
  // 0 de b"
  return t(tm.acierta ? 'groups.avance.cuadro' : 'groups.avance.cuadro_ninguna', {
    alumno, tema, estado: t(`groups.avance.estado.${tm.estado}`), a: tm.acierta, b: tm.contestadas,
  });
}

/** El tema de "Por card" (con sus preguntas y sus cajas) de una card. */
export function temaDeLaCard(datos, cardId, temaId) {
  const card = (datos?.cards || []).find((c) => c.publicacion_id === cardId);
  return card ? (card.temas || []).find((tm) => tm.tema_id === temaId) || null : null;
}

/** El chip de caducidad de un mosaico (seccion 3.3): caducada -> "caduco el"; activa que
    caduca en 14 dias o menos -> "caduca hoy" / "caduca manana" / "caduca en n dias"; si no,
    ninguno. */
export function chipDeCaduca(card) {
  if (!card || !card.caduca) return null;
  if (card.caducada) return { llave: 'caduco_el', rojo: false };
  const n = card.caduca_en_dias;
  if (n === null || n === undefined || n > 14) return null;
  if (n <= 0) return { llave: 'caduca_hoy', rojo: true };
  return { llave: 'caduca_en', count: n, rojo: true };
}

/** Parte un texto en pedazos con el primer "x de y" / "x of y" (o "x de los y que la
    contestaron") en negritas. */
export function negritasXdeY(texto) {
  const s = String(texto || '');
  // "21 de 40", y en la caja de una pregunta "6 de los 8 que la contestaron" (seccion 3.2)
  const m = /\d+ (?:de|of)(?: (?:los|the))? \d+(?: (?:que la contestaron|who answered it))?/.exec(s);
  if (!m) return [{ t: s, b: false }];
  return [
    { t: s.slice(0, m.index), b: false },
    { t: m[0], b: true },
    { t: s.slice(m.index + m[0].length), b: false },
  ].filter((p) => p.t);
}
